import Link from '@src/components/base/Link';

import SidebarItem from './SidebarItem';


/** Active nav row per the .pen Sidebar: faint primary tint, primary icon, ink label. */
const activeClassName = 'bg-primary/12 font-semibold text-ink [&_svg]:text-primary';

function SidebarNavItem(props) {
  const { exact = true, ...restProps } = props;
  return (
    <SidebarItem
      as={Link}
      activeOptions={{ exact }}
      activeProps={{ className: activeClassName }}
      {...restProps}
    />
  );
}

SidebarNavItem.displayName = 'SidebarNavItem';
export default SidebarNavItem;
